/**
 * Class for creating modals
 */
export default class Modal {
  /**
   * @param {String} title
   * @param {String} content
   * @param {{center: Boolean, size: ('normal'|'narrow') }=} options
   */
  constructor(name, title, content, { center = false, size = 'normal', style='' } = {}) {
    this.el = this._createNodeTree(title, content)
    this.name = name
    this.mounted = false
    this.dontShowAgain = false

    if (center) this.el.classList.add('modal--center')
    if (size === 'narrow') this.el.classList.add('modal--narrow')
    if (style === 'side') this.el.classList.add('modal--style-side')
  }

  _createNodeTree(title, content) {
    const titleEl = document.createElement('h3')
    titleEl.className = 'modal__title'
    titleEl.innerHTML = title

    const contentEl = document.createElement('div')
    contentEl.className = 'modal__content'
    contentEl.innerHTML = content

    const closeEl = document.createElement('div')
    closeEl.className = 'modal__close'
    closeEl.addEventListener('click', () => this.unmount())

    const boxEl = document.createElement('div')
    boxEl.className = 'modal__box has-white-background-color'
    boxEl.appendChild(titleEl)
    boxEl.appendChild(contentEl)
    boxEl.appendChild(closeEl)

    const modal = document.createElement('div')
    modal.className = 'modal'
    modal.appendChild(boxEl)

    return modal
  }

  open(delay = 0, dontShowAgain, dontShowAgainInSession) {
    if ( dontShowAgain && this.getDismissed().includes(this.name) ) return
    if ( dontShowAgainInSession && this.wasSeenInSession() ) return

    setTimeout(() => {
      !this.mounted && this.mount()
      dontShowAgain && (this.dontShowAgain = true)
      dontShowAgainInSession && (this.dontShowAgainInSession = true)

      this.el.classList.remove('hidden')
      setTimeout(() => this.el.classList.remove('will-mount'), 50)

      window.sessionStorage.setItem('seen-modal-' + this.name, 'true')
    }, parseInt(delay * 1000))
  }

  mount() {
    if (!this.el) return

    this.el.classList.add('hidden', 'will-mount')
    document.body.appendChild(this.el)
  }

  unmount() {
    if (!this.el) return

    // If modal shall not be shown again, save it to cookie for 30 days
    if (this.dontShowAgain) {
      const dismissedModals = this.getDismissed()
      dismissedModals.push(this.name)
      window.cookies.setCookie('dismissed-modals', dismissedModals.join(','), 30)
    }

    this.el.classList.add('will-unmount')

    setTimeout(() => {
      this.el.remove()
      this.el.classList.remove('will-unmount')
    }, 500)
  }

  getDismissed() {
    return window.cookies.getCookie('dismissed-modals').split(',').filter(i => i)
  }

  wasSeenInSession() {
    return window.sessionStorage.getItem('seen-modal-' + this.name)
  }

  destroy() {
    this.el = undefined
  }
}